angular.module('lsnBase.deprecated.models')
  .factory('WorkerModel', ['LsnWorkerModelV1',
    function(LsnWorkerModelV1) {
      return LsnWorkerModelV1;
    }
  ]);